import http from "@/http-common";
import {
	FETCH_ALL_NOTES,
	GET_ALL_NOTES,
	GET_NOTES_FOR_CHATBOT,
	GET_NOTES_FOR_SALE,
	COPY_NOTE_FOR_USER,
} from "@/api/Constants";
import Api from "@/api/methods/Api";

class ApiNotes extends Api {
	fetchAllNotesDashboardData(token, params) {
		return token != null
			? http.post(FETCH_ALL_NOTES, params, this.headers(token))
			: http.post(FETCH_ALL_NOTES, params);
	}

	getAllNotes(token, params) {
		return token != null
			? http.post(GET_ALL_NOTES, params, this.headers(token))
			: http.post(GET_ALL_NOTES, params);
	}

	getNotesForChatbot(noteType, noteIds) {
		return http.post("/api/getNotesForChatbot", { noteType, noteIds: noteIds || [] });
	}

	getNoteDashboardData(token, params) {
		return token != null
			? http.post(GET_NOTES_FOR_SALE, params, this.headers(token))
			: http.post(GET_NOTES_FOR_SALE, params);
	}

	copyNoteForUser(token, params) {
		return  http.post(COPY_NOTE_FOR_USER, params, this.headers(token));
	}

	getUserFilterStatusModel(forSale) {
		let url = "/api/getUserFilterStatusModel/1";
		if (!forSale) {
			url = "/api/getUserFilterStatusModel/0";
		}
		return http.get(url);
	}
}

export default new ApiNotes();
